import script from "./RechnerStep1.vue?vue&type=script&setup=true&lang=js"
export * from "./RechnerStep1.vue?vue&type=script&setup=true&lang=js"

import "./RechnerStep1.vue?vue&type=style&index=0&id=0dcfe50c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0dcfe50c"]])

export default __exports__